import { render } from "./FAQItem.vue?vue&type=template&id=5615bf54&scoped=true"
import script from "./FAQItem.vue?vue&type=script&lang=js"
export * from "./FAQItem.vue?vue&type=script&lang=js"

import "./FAQItem.vue?vue&type=style&index=0&id=5615bf54&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5615bf54"]])

export default __exports__